import { Button } from '@/cn/ui/button'
import { PasskeyUtil } from '@/utils/passkey'
import { Navigate, useNavigate } from 'react-router-dom'

const Home = () => {
  const navigate = useNavigate()
  const passkeyUsers = PasskeyUtil.LoggedUser()
  let query = new URLSearchParams(window.location.search)
  let notification = query.get('notification')
  if (passkeyUsers.length) {
    return <Navigate to={'/auth' + (notification ? `?notification=${notification}` : '')} />
  }
  return (
    <div className="flex flex-col items-center justify-between h-full relative text-foreground">
      <h1 className="text-[30px] font-bold mt-16 shrink-0 mb-3 tracking-[-0.01em]">
        Welcome to <span className="text-primary">Cray!</span>
      </h1>
      {/* <p className="text-center w-[343px] text-[22px] font-normal text-[hsla(0,0%,39%,1)] ">Our money. Our way. <br/> Simple, fast, made for us.</p> */}
      <div className="w-full px-6">
        <p className="mx-auto max-w-[343px] text-center text-[18px] md:text-[20px] font-semibold leading-snug">Our money. Our way.</p>
        <p className="mx-auto max-w-[343px] text-center text-[14px] md:text-[15px] text-neutral-600 leading-tight mt-1">Simple, fast, made for us.</p>
      </div>
      <div className="flex-grow flex items-center">
        <img className=" mt-12  w-full px-3" src="/welcome_illustration.png" />
      </div>
      <div className="flex flex-col  w-full justify-between items-center p-4 gap-2 pb-8">
        <Button onClick={() => navigate('auth')} className=" w-full">
          Create Account
        </Button>
        <Button onClick={() => navigate('auth#signin')} className=" w-full" variant="outline">
          Login
        </Button>
      </div>
    </div>
  )
}
export default Home
